let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iGdgf")).then(() => parcelRequire('3tsG4'));